/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWithRolesAndSites } from '../../models/client-with-roles-and-sites';
import { KeyType } from '../../models/key-type';

export interface GetClients$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
}

export function getClients(http: HttpClient, rootUrl: string, params: GetClients$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientWithRolesAndSites>>> {
  const rb = new RequestBuilder(rootUrl, getClients.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientWithRolesAndSites>>;
    })
  );
}

getClients.PATH = '/administration/organizations/{organizationKey}/clients';
